import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
/** Optional birthday confirmation must not send an empty Magento customer input. */
export var saveOptionalBirthday = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    var {
      dob,
      updateCustomer
    } = _ref;
    if (typeof dob !== "string" || !dob.trim()) return;
    return updateCustomer({
      variables: {
        dob: dob.trim()
      }
    });
  });
  return function saveOptionalBirthday(_x) {
    return _ref2.apply(this, arguments);
  };
}();